import { useState, useEffect, useRef } from "react";
import {
  Autocomplete,
  Grid,
  TextField,
  CurrencyInput,
  DataGrid,
  Button,
  FormControl,
  DocumentoProdutoAplicacaoDialog,
  IconButton,
  Tooltip,
  ProdutoEstoqueInformacaoDialog,
} from "../../../../../components";
import {
  ProdutosService,
  SessionService,
  UnidadeComercialService,
  notification,
} from "../../../../../services";
import { ProdutoSimilarDialog } from "..";
import { PermisoesHelper, value } from "../../../../../helpers";
import {
  responseErros,
  formatPrice,
  unformatPrice,
} from "../../../../../utils";
import shortid from "shortid";
import { calcularValorTotal } from "../../add-condicional";
import TabelaCustoDialog from "../../../../../components/tabela-custo-dialog/tabela-custo-dialog.component";

const unidadeComercialService = new UnidadeComercialService();
const produtosService = new ProdutosService();

const CondicionaisItens = ({
  id,
  condicional,
  setCondicional,
  produtoList,
  setProdutoList,
  listaCondicionaisProdutos,
  setListaCondicionaisProdutos,
  tabelaPrecoCliente,
  removerProdutoCadastrado,
  setLoading,
  timeoutBuscaAutocomplete,
  origensMercadoriasList,
  listaUnidadesComerciais,
  setListaUnidadesComerciais,
  condicionalEntity,
  buscarProdutosSimilares,
  produtosSimilares,
  setProdutosSimilares,
}) => {
  const inputRef = useRef();
  const [produto, setProduto] = useState(null);
  const [loadingAutoCompleteProd, setLoadingAutoCompleteProd] = useState();
  const [isProdutoEdit, setIsProdutoEdit] = useState(false);
  const [openProdutoSimilarDialog, setOpenProdutoSimilarDialog] =
    useState(false);
  const [openProdutoAplicacoesDialog, setOpenProdutoAplicacoesDialog] =
    useState(false);
  const [
    openProdutoEstoqueInformacaoDialog,
    setOpenProdutoEstoqueInformacaoDialog,
  ] = useState(false);
  const [produtosTabelaCusto, setProdutosTabelaCusto] = useState([]);
  const [totaisTabelaCusto, setTotaisTabelaCusto] = useState([]);
  const [openTabelaCustoDialog, setOpenTabelaCustoDialog] = useState(false);

  const permissoesHelper = new PermisoesHelper();
  const tabelaCustoPermissao = permissoesHelper.temPermisao(
    "tabela-custo-visualizar",
  );

  const sessionService = new SessionService();
  const { configuracoes } = sessionService.getEmpresa();
  const usuario = sessionService.getUsuario();

  const colunas = [
    {
      field: "codigo",
      headerName: "Cod.",
      flex: 100,
    },
    {
      field: "descricao",
      headerName: "Produto",
      flex: 400,
    },
    {
      field: "quantidade",
      headerName: "Quantidade",
      flex: 150,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        Number.isInteger(parseFloat(params.value))
          ? params.value
          : params.value.toFixed(3).replace(".", ","),
    },
    {
      field: "valorUnitario",
      headerName: "Unitário (R$)",
      flex: 200,
      headerAlign: "right",
      align: "right",
      valueGetter: (params) =>
        params.value ? formatPrice(parseFloat(params.value), false) : "",
    },
    {
      field: "totalItem",
      headerName: "Total dos Itens (R$)",
      flex: 300,
      headerAlign: "right",
      align: "right",
      valueGetter: (params) =>
        params.value ? formatPrice(parseFloat(params.value), false) : "",
    },
    {
      field: "acoes",
      headerName: "Ações",
      sortable: false,
      flex: 120,
      align: "center",
      headerAlign: "center",
      disableClickEventBubbling: true,
      renderCell: (params) => {
        return (
          <div>
            {!params.row.origemKitId && (
              <IconButton
                onClick={() => {
                  onClickEditCondicionaisItens(params.id);
                }}
              >
                <Tooltip title="Editar" arrow placement="right">
                  <i className="ph-fill ph-pencil" style={{ fontSize: 18 }}></i>
                </Tooltip>
              </IconButton>
            )}
            <IconButton
              onClick={(event) => {
                event.stopPropagation();
                onClickDeleteCondicionaisItens(params.id);
              }}
            >
              <Tooltip title="Excluir" arrow placement="right">
                <i className="ph-fill ph-trash" style={{ fontSize: 18 }}></i>
              </Tooltip>
            </IconButton>
          </div>
        );
      },
    },
  ];

  const produtosColunasSimilares = [
    {
      field: "codigo",
      headerName: "Cod.",
      flex: 280,
    },
    {
      field: "descricao",
      headerName: "Produtos",
      flex: 700,
    },
    {
      field: "estoqueAtual",
      headerName: "Estoque",
      flex: 350,
    },
    {
      field: "precoVenda",
      headerName: "Preço Venda",
      flex: 500,
      valueGetter: (params) => formatPrice(params.value),
    },
    {
      field: "acoes",
      sortable: false,
      disableClickEventBubbling: true,
      renderHeader: () => {
        return (
          <i
            className="ph-fill ph-note-pencil"
            style={{ fontSize: 20, marginLeft: 14 }}
          ></i>
        );
      },
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              if (params.row) {
                setOpenProdutoSimilarDialog(false);
                setProdutosSimilares([]);
                handleChangeAutocompleteProduto(params.row, false, true);
              }
            }}
            sx={{
              "&:hover": { backgroundColor: "transparent" },
            }}
          >
            <i
              className="ph-fill ph-paper-plane-right"
              style={{ fontSize: 20, marginLeft: 14 }}
            ></i>
          </IconButton>
        );
      },
    },
  ];

  const buscarProdutos = (
    filtros,
    isProdutoSimilar = false,
    isCodigoBarras = false,
  ) => {
    const filtro = {
      ...filtros,
      orderBy: "codigo",
      order: "asc",
      ativado: true,
      limite: 20,
    };
    produtosService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setLoadingAutoCompleteProd(false);
        if (isProdutoSimilar && result.data.rows?.length) {
          const itens = result.data.rows.map((item) => {
            const { informacao, ...rest } = item;
            const produtoResultante = { ...rest, ...informacao, id: rest.id };
            const unidadeProduto = listaUnidadesComerciais.find(
              (unidade) =>
                unidade.id == produtoResultante.unidadeComercialVendaId,
            );
            return montarItem({ ...produtoResultante, unidadeProduto }, false);
          });
          setProdutosSimilares(itens);
          setLoading(false);
          return;
        }

        if (isCodigoBarras) {
          handleChangeAutocompleteProduto(result.data.rows[0], true);
        } else {
          setProdutoList(result.data.rows);
        }
      } else {
        setLoadingAutoCompleteProd(false);
        responseErros(result);
      }
    });
  };

  const buscarProdutoKit = async (produtoId) => {
    if (produtoId) {
      const result = await produtosService.getById(produtoId);
      if (!result.isAxiosError) {
        return result.data;
      } else {
        responseErros(result);
      }
    }
  };

  const buscarProdutosByCodigo = async (codigoBarra, valorProduto) => {
    const result = await produtosService.getAllProdutosByCodigo({
      codigoBarra,
    });
    if (!result.isAxiosError) {
      setLoadingAutoCompleteProd(false);
      if (result.data.length === 0) return;
      let produto = result.data[0];
      let quantidade = null;
      if (valorProduto) {
        quantidade =
          Math.round((valorProduto / produto.informacao.precoVenda) * 1000) /
          1000;
      }
      produto = {
        ...produto,
        quantidade,
        totalItem: valorProduto,
      };
      handleChangeAutocompleteProduto(produto, true);
      setLoading(false);
    } else {
      setLoadingAutoCompleteProd(false);
      responseErros(result);
    }
  };

  const onInputChangeProdutos = (event) => {
    const eventValue = event.target?.value.includes(",")
      ? event.target?.value.split(",")[0]
      : event.target?.value;
    if (
      event.key === "Backspace" &&
      inputRef.current === document.activeElement &&
      eventValue === ""
    ) {
      setProdutoList([]);
    }
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      const filtros = {
        codigo: eventValue,
        descricao: eventValue,
        codigoBarra: eventValue,
      };
      const validacaoCodigoNumerico = Number.isFinite(parseFloat(eventValue));
      const isCodigoBalanca =
        configuracoes.inicialCodigoBarrasBalanca ===
          parseFloat(eventValue[0]) && eventValue.length >= 7;
      setLoadingAutoCompleteProd(true);
      if (
        validacaoCodigoNumerico &&
        (configuracoes.buscaProdutosCodigoBarras || isCodigoBalanca)
      ) {
        const codigo = isCodigoBalanca ? eventValue.slice(0, 7) : eventValue;
        let valorProduto = null;
        if (isCodigoBalanca && eventValue.length >= 12) {
          valorProduto =
            parseInt(eventValue.slice(7, 12).replace(/^0+/, "")) / 100;
        }
        timeoutBuscaAutocomplete(buscarProdutosByCodigo(codigo, valorProduto));
      } else {
        const isCodigoBarras =
          validacaoCodigoNumerico && eventValue.length >= 8;
        timeoutBuscaAutocomplete(
          buscarProdutos(filtros, false, isCodigoBarras),
        );
      }
    }
  };

  const buscarUnidadesComerciais = () => {
    if (listaUnidadesComerciais?.length) return;
    unidadeComercialService.getAll().then((res) => {
      if (!res.isAxiosError) {
        setListaUnidadesComerciais(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const onClickDeleteCondicionaisItens = async function (idProduto) {
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir essa conta?`,
    );
    let listaItens = [];
    const produto = listaCondicionaisProdutos.find(
      (produto) => produto.id == idProduto,
    );
    if (retornoAlerta.isConfirmed) {
      if (id) {
        if (produto.origemKitId) {
          listaItens = listaCondicionaisProdutos
            .filter((item) => item.origemKitId === produto.origemKitId)
            .map(({ id }) => id);
        } else {
          listaItens.push(idProduto);
        }
        removerProdutoCadastrado({ idItens: listaItens });
      } else {
        if (produto.origemKitId) {
          listaItens = listaCondicionaisProdutos.filter(
            (item) => item.origemKitId !== produto.origemKitId,
          );
        } else {
          listaItens = listaCondicionaisProdutos.filter(
            (produto) => produto.id != idProduto,
          );
        }
        setListaCondicionaisProdutos(listaItens);
        condicionalEntity.setChangeItens(listaItens);
        setCondicional(condicionalEntity);
      }
    }
  };

  const handleChangeAutocompleteProduto = (
    produtoEscolhido,
    isBuscaCodBar = false,
  ) => {
    document.getElementById("produtoId").blur();
    if (produtoEscolhido) {
      const { informacao, ...rest } = produtoEscolhido;
      const produtoResultante = { ...rest, ...informacao, id: rest.id };
      const unidadeProduto = listaUnidadesComerciais.find(
        (unidade) => unidade.id == produtoResultante.unidadeComercialVendaId,
      );
      const itemTemp = montarItem({
        ...produtoResultante,
        unidadeProduto,
      });
      setProduto(itemTemp);
      if (produtoResultante.similares?.length && !isBuscaCodBar) {
        const listaIdsProdutosSimilares = produtoResultante.similares.map(
          ({ similarId }) => similarId,
        );
        setLoading(true);
        buscarProdutos({ id: listaIdsProdutosSimilares }, true);
      }
      if (!isBuscaCodBar) {
        document.getElementById("buttonAdicionar").focus();
      } else {
        handleAdicionarProduto(itemTemp);
      }
    } else {
      setProdutosSimilares([]);
      setProduto(null);
    }
  };

  const montarItem = (produtoResultante, insertItem = true) => {
    const quantidade = produtoResultante.quantidade ?? 1;
    const totalItem =
      produtoResultante.totalItem ?? produtoResultante.precoVenda;
    let itemTemp = {
      ...produtoResultante,
      quantidade,
      unidade: produtoResultante.unidadeProduto
        ? produtoResultante.unidadeProduto?.codigo
        : "",
      estoqueAtual: produtoResultante?.estoqueProduto?.estoque
        ? `${produtoResultante.estoqueProduto.estoque}`
        : 0,
      valorUnitario: produtoResultante.precoVenda,
      totalItem,
      produtoId: produtoResultante?.id,
      descricao: produtoResultante?.descricao || "",
      codigo: produtoResultante?.codigo,
      tributosIcmsOrigem: origensMercadoriasList.find(
        (item) => item.id == produtoResultante.origemMercadoriaId,
      )?.codigo,
      ncm: produtoResultante?.ncmCodigo,
    };
    if (insertItem) {
      itemTemp = { ...produto, ...itemTemp };
    }
    return itemTemp;
  };

  useEffect(() => {
    if (listaCondicionaisProdutos.length > 0 && produto) {
      const produtosAtualizados = listaCondicionaisProdutos.map((produto) => {
        const precoProduto = produto.precoVenda ?? produto.valorUnitario;
        return {
          ...produto,
          valorUnitario: precoProduto,
          totalItem: precoProduto * produto.quantidade,
        };
      });
      condicionalEntity.setChangeItens(produtosAtualizados);
      setCondicional(condicionalEntity);
      setListaCondicionaisProdutos(produtosAtualizados);
    }
  }, [tabelaPrecoCliente]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    const produtoTemp = {
      ...produto,
      [event.target.name]: value || null,
    };
    produtoTemp.totalItem = calcularValorTotal(produtoTemp);
    setProduto(produtoTemp);
  };

  function onBlurQtd(e) {
    let valorQtd = parseFloat(e.target.value);
    setProduto((prevState) => ({ ...prevState, quantidade: valorQtd }));
  }

  const handleInputBlur = (event) => {
    const produtoTemp = {
      ...produto,
      [event.target.name]: unformatPrice(event.target.value) || null,
    };
    produtoTemp.totalItem = calcularValorTotal(produtoTemp);
    setProduto(produtoTemp);
  };

  const onClickEditCondicionaisItens = async (id) => {
    const item = listaCondicionaisProdutos.find((item) => item.id === id);
    if (item.status === "FECHADO") {
      return notification.alertaGenericos(
        "Ítem já importado não pode ser editado",
      );
    }
    if (item) setIsProdutoEdit(true);
    setProduto(item);
  };

  const validarAddProduto = (produto) => {
    if (!produto) {
      notification.alertaGenericos("Selecione um produto para adicionar");
      return true;
    }
    if (!produto.quantidade) {
      notification.erroValidacao("Quantidade do produto");
      return true;
    }
    if (!produto.unidade) {
      notification.erroValidacao("Unidade do produto");
      return true;
    }
  };

  const handleAdicionarProduto = async (produto) => {
    if (validarAddProduto(produto)) return;
    let listaItens = [];
    if (isProdutoEdit) {
      const produtoIndex = listaCondicionaisProdutos.findIndex(
        (item) => item.id === produto.id,
      );
      if (produtoIndex >= 0) {
        listaItens = listaCondicionaisProdutos.map((item, _index) =>
          _index === produtoIndex
            ? {
                ...item,
                ...produto,
              }
            : item,
        );
      }
    } else {
      if (produto.tipo === "kit" && produto.envioKitItensFiscal) {
        const result = await buscarProdutoKit(produto.id);
        const kitItens = result.kits.map((item) => {
          const itemProduto = item.produto;
          const quantidade = produto.quantidade * item.quantidade;
          const unidadeProduto = listaUnidadesComerciais.find(
            (unidade) => unidade.id == itemProduto.unidadeComercialVendaId,
          );
          return {
            ...itemProduto,
            quantidade,
            valorUnitario: itemProduto.informacao.precoVenda,
            totalItem: quantidade * itemProduto.informacao.precoVenda,
            origemKitId: result.id,
            produtoId: itemProduto.id,
            ncm: itemProduto.informacao.ncmCodigo,
            unidade: unidadeProduto ? unidadeProduto?.codigo : "",
            tributosIcmsOrigem: origensMercadoriasList.find(
              (item) => item.id == itemProduto.origemMercadoriaId,
            )?.codigo,
            id: shortid.generate(),
          };
        });
        listaItens = [...listaCondicionaisProdutos, ...kitItens];
      } else {
        listaItens = [
          ...listaCondicionaisProdutos,
          {
            ...produto,
            id: shortid.generate(),
          },
        ];
      }
    }
    setListaCondicionaisProdutos(listaItens);
    condicionalEntity.setChangeItens(listaItens);
    setCondicional(condicionalEntity);
    document.getElementById("produtoId").focus();
    setIsProdutoEdit(false);
    setProduto(null);
    setProdutoList([]);
    setProdutosSimilares([]);
  };

  useEffect(() => {
    buscarUnidadesComerciais();
  }, []);

  const openProdutoSimilar = () => {
    if (produto === null) {
      notification.alertaGenericos(
        "Selecione um produto primeiro para colocar produto similar",
      );
    } else {
      setOpenProdutoSimilarDialog(true);
    }
  };

  const openAplicacoesDialog = () => {
    if (produto === null) {
      notification.alertaGenericos(
        "Selecione um produto primeiro para colocar produto similar",
      );
    } else {
      setOpenProdutoAplicacoesDialog(true);
    }
  };

  const openEstoqueDialog = (produtoEscolhido = produto) => {
    if (produtoEscolhido === null) {
      notification.alertaGenericos("Selecione um produto primeiro");
    } else {
      setOpenProdutoEstoqueInformacaoDialog(true);
    }
  };

  const handleOpenTabelaCustoDialog = () => {
    const produtosTabelaCusto = listaCondicionaisProdutos.map((item) => {
      const quantidade = item.quantidade || 0;
      const precoCusto = item.precoCusto || 1;
      const precoVenda = item.totalItem || 1;
      const totalCustoItem = precoCusto * quantidade;
      const diferenca = ((precoVenda - totalCustoItem) / totalCustoItem) * 100;
      return {
        ...item,
        total: formatPrice(totalCustoItem, false),
        dif: formatPrice(diferenca, false),
      };
    });
    let totaisTabelaCusto = { totalCusto: 0, totalVenda: 0 };
    listaCondicionaisProdutos.forEach((item) => {
      const totalCusto =
        totaisTabelaCusto.totalCusto +
        (item.precoCusto || 0) * (item.quantidade || 0);
      const totalVenda = totaisTabelaCusto.totalVenda + item.totalItem || 0;
      totaisTabelaCusto.totalCusto = Math.round(totalCusto * 100) / 100;
      totaisTabelaCusto.totalVenda = Math.round(totalVenda * 100) / 100;
    });

    const totalDif =
      totaisTabelaCusto.totalVenda - totaisTabelaCusto.totalCusto;
    totaisTabelaCusto = {
      ...totaisTabelaCusto,
      totalDif: formatPrice(totalDif, false),
      percentualDif: formatPrice(
        (totalDif / totaisTabelaCusto.totalCusto) * 100,
        false,
      ),
    };

    setProdutosTabelaCusto(produtosTabelaCusto);
    setTotaisTabelaCusto(totaisTabelaCusto);
    setOpenTabelaCustoDialog(true);
  };

  return condicional.status === "CANCELADO" ||
    condicional.status === "BAIXADO" ? (
    <>
      <DataGrid
        rows={listaCondicionaisProdutos}
        rowCount={listaCondicionaisProdutos.length}
        columns={colunas}
      />
      <ProdutoSimilarDialog
        produto={produto}
        openProdutoSimilarDialog={openProdutoSimilarDialog}
        setOpenProdutoSimilarDialog={setOpenProdutoSimilarDialog}
        buscarProdutosSimilares={buscarProdutosSimilares}
        produtosColunasSimilares={produtosColunasSimilares}
        produtosSimilares={produtosSimilares}
      />
    </>
  ) : (
    <Grid container className="position-relative">
      <Grid
        container
        spacing={2}
        className="mb-2"
        alignItems="center"
        justifyContent="space-between"
        columns={15}
      >
        <Grid
          item
          xs={15}
          md={
            produtosSimilares?.length || produto?.aplicacoes?.length ? 4.5 : 5.5
          }
        >
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="produtoId"
              name="produtoId"
              options={produtoList}
              autoHighlight
              loading={loadingAutoCompleteProd}
              loadingText="Carregando"
              noOptionsText="Digite e clique no ícone para buscar"
              renderOption={(props, option) => {
                let descricaoProduto = `${option?.codigo} - ${option?.descricao}`;
                return option ? (
                  <li {...props}>
                    <div className="d-flex justify-content-between w-100">
                      <div>{descricaoProduto}</div>
                      <div>{option?.estoqueProduto?.estoque}</div>
                    </div>
                  </li>
                ) : (
                  ""
                );
              }}
              getOptionLabel={(option) => {
                let descricaoProduto = `${option?.codigo} - ${option?.descricao}`;
                return option ? descricaoProduto : "";
              }}
              filterSelectedOptions
              onChange={(_, value) => handleChangeAutocompleteProduto(value)}
              value={produto ?? ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Buscar produto"
                  required
                  onKeyDown={(e) => onInputChangeProdutos(e)}
                  inputRef={inputRef}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={0.5} sx={{ mt: "0.5em" }}>
          <Tooltip title="Estoque e Informação do Item" placement="bottom">
            <Button
              id="buttonEstoqueInformacaoItem"
              variant="contained"
              color="primary"
              disabled={!produto}
              size="small"
              sx={{
                height: "35px",
                borderRadius: "20%",
                minWidth: "15px",
                boxShadow: "none",
              }}
              onClick={() => openEstoqueDialog()}
            >
              <i
                className="ph-fill ph-package"
                style={{ color: "#fff", fontSize: 15 }}
              ></i>
            </Button>
          </Tooltip>
        </Grid>
        {produto?.aplicacoes?.length ? (
          <Grid item xs={0.5} sx={{ mt: "0.5em" }}>
            <Tooltip title="Aplicações do item" placement="bottom">
              <Button
                id="buttonAplicacoesItem"
                variant="contained"
                color="primary"
                size="small"
                sx={{
                  height: "35px",
                  borderRadius: "20%",
                  minWidth: "15px",
                  boxShadow: "none",
                }}
                onClick={() => openAplicacoesDialog()}
              >
                <i
                  className="ph-fill ph-circles-three"
                  style={{ color: "#fff", fontSize: 15 }}
                ></i>
              </Button>
            </Tooltip>
          </Grid>
        ) : null}
        {produtosSimilares?.length ? (
          <Grid item xs={0.5} sx={{ mt: "0.5em" }}>
            <Tooltip title="Consultar Similares" placement="bottom">
              <Button
                id="buttonSimilarItem"
                variant="contained"
                color="primary"
                size="small"
                sx={{
                  height: "35px",
                  borderRadius: "20%",
                  minWidth: "15px",
                  boxShadow: "none",
                }}
                onClick={openProdutoSimilar}
              >
                <i
                  className="ph-bold ph-approximate-equals"
                  style={{ color: "#fff", fontSize: 15 }}
                ></i>
              </Button>
            </Tooltip>
          </Grid>
        ) : null}
        <Grid item xs={1}>
          <TextField
            id="estoque"
            name="estoque"
            label="Estoque"
            margin="normal"
            variant={"outlined"}
            disabled
            value={value.text(produto?.estoqueAtual)}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={1}>
          <TextField
            id="unidade"
            name="unidade"
            label="Unidade"
            margin="normal"
            variant={"outlined"}
            disabled
            value={value.text(produto?.unidade)}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            id="quantidade"
            name="quantidade"
            label="Quantidade"
            variant={!produto ? "filled" : "outlined"}
            disabled={!produto}
            InputProps={
              produto?.fracionavel
                ? { inputProps: { min: 0.01, step: 0.01 } }
                : { inputProps: { min: 1, step: 1 } }
            }
            value={value.text(produto?.quantidade)}
            onChange={(e) => {
              if (e.target.value <= 0) e.target.value = "";
              if (produto?.fracionavel) {
                e.target.value = Number(e.target.value);
              } else {
                e.target.value = Math.trunc(Number(e.target.value));
              }
              handleInputChange(e);
            }}
            onBlur={onBlurQtd}
            margin="normal"
            type="number"
            required
          />
        </Grid>
        <Grid item xs={2}>
          <CurrencyInput
            id="valorUnitario"
            name="valorUnitario"
            label="Valor Unitário R$"
            variant={!produto ? "filled" : "outlined"}
            disabled={!produto || produto?.tipo === "kit"}
            value={value.text(produto?.valorUnitario)}
            onBlur={handleInputBlur}
          />
        </Grid>
        <Grid item xs={2}>
          <CurrencyInput
            id="totalItem"
            name="totalItem"
            label="Total Item R$"
            variant={!produto ? "filled" : "outlined"}
            disabled={!produto || produto?.tipo === "kit"}
            value={value.text(produto?.totalItem)}
            onBlur={handleInputBlur}
          />
        </Grid>
        <Grid item xs={1} sx={{ mt: "0.5em" }}>
          {isProdutoEdit ? (
            <Button
              id="buttonAdicionar"
              variant="contained"
              size="small"
              sx={{
                height: "35px",
                borderRadius: "50%",
                minWidth: "15px",
                boxShadow: "none",
              }}
              onClick={() => handleAdicionarProduto(produto)}
            >
              <i
                className="ph-bold ph-arrows-clockwise"
                style={{ color: "#fff", fontSize: 15 }}
              ></i>
            </Button>
          ) : (
            <Button
              id="buttonAdicionar"
              variant="contained"
              color="success"
              size="small"
              sx={{
                height: "35px",
                borderRadius: "50%",
                minWidth: "15px",
                boxShadow: "none",
              }}
              onClick={() => handleAdicionarProduto(produto)}
            >
              <i
                className="ph-bold ph-plus"
                style={{ color: "#fff", fontSize: 15 }}
              ></i>
            </Button>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid style={{ marginTop: 32 }} item xs={12}>
          <DataGrid
            style={{ zIndex: 1 }}
            rows={listaCondicionaisProdutos}
            rowCount={listaCondicionaisProdutos.length}
            columns={colunas}
            disableAcoes
          />
        </Grid>
        {tabelaCustoPermissao && listaCondicionaisProdutos.length > 0 && (
          <Grid item xs={12} display="flex" justifyContent="flex-end">
            <Button
              className="mb-3"
              size="large"
              variant="contained"
              color="primary"
              onClick={() => handleOpenTabelaCustoDialog(true)}
            >
              <i
                className="ph-fill ph-table"
                style={{ color: "#fff", fontSize: 22, marginRight: 10 }}
              ></i>
              Tabela de Custo
            </Button>
          </Grid>
        )}
      </Grid>
      <ProdutoSimilarDialog
        produto={produto}
        openProdutoSimilarDialog={openProdutoSimilarDialog}
        setOpenProdutoSimilarDialog={setOpenProdutoSimilarDialog}
        buscarProdutosSimilares={buscarProdutosSimilares}
        produtosColunasSimilares={produtosColunasSimilares}
        produtosSimilares={produtosSimilares}
      />
      <ProdutoEstoqueInformacaoDialog
        produto={produto}
        open={openProdutoEstoqueInformacaoDialog}
        setOpen={setOpenProdutoEstoqueInformacaoDialog}
        usuario={usuario}
        handleChangeAutocompleteProduto={handleChangeAutocompleteProduto}
      />
      <DocumentoProdutoAplicacaoDialog
        open={openProdutoAplicacoesDialog}
        setOpen={setOpenProdutoAplicacoesDialog}
        aplicacoesProduto={produto?.aplicacoes}
      />
      <TabelaCustoDialog
        openDialog={openTabelaCustoDialog}
        setOpenDialog={setOpenTabelaCustoDialog}
        produtos={produtosTabelaCusto}
        totais={totaisTabelaCusto}
      />
    </Grid>
  );
};

export default CondicionaisItens;
